module.exports = __webpack_public_path__ + "img/Bergens_Kapitelsbok_Dagboksjangeren.4a0e0caa.jpg";